import React from 'react';
import { AppRouter } from './routers/AppRouter';
import './styles/app.scss';

export const App = () => {
  return (
    <div>
      <AppRouter />
    </div>
  )
}

